import React from "react";
import "./cxm-route-loader.scss";

/**
 * What a CXM tenant shows before the session token has been exchanged, i.e.
 * before any page can mount.
 *
 * Deliberately motionless. `CxmRouteLoader` plays a one-shot entrance, and it
 * is the page — not this guard — that mounts it; showing an animated loader
 * here would play that entrance twice, restarting the logo mid-trace. So this
 * is only the themed surface the pane then fades in over.
 */
const CxmBootSurface: React.FC = (): JSX.Element => (
  <div className="cxm-boot-surface" role="status" aria-live="polite" aria-busy="true" />
);

export default CxmBootSurface;
